import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspacePermissionsFragment = { __typename?: 'Workspace', permissions?: { __typename?: 'WorkspacePermissions', canCreateProject: boolean, canDelete: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canUpdate: boolean } | null };

export const WorkspacePermissions = /*#__PURE__*/ gql`
    fragment WorkspacePermissions on Workspace {
  permissions {
    canCreateProject
    canDelete
    canEditUserPermissions
    canManageResourceControlPolicies
    canUpdate
  }
}
    ` as unknown as DocumentNode<WorkspacePermissionsFragment, unknown>;

        

        
export const useWorkspacePermissionsFragment = (
  input: string | Omit<UseFragmentOptions<WorkspacePermissionsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspacePermissionsFragment>({
    fragment: WorkspacePermissions,
    fragmentName: 'WorkspacePermissions',
    ...options,
  });
};
  
        